// removed by extract-text-webpack-plugin
module.exports = {"PracticePage":"style_PracticePage--GXktM4-i","practicePage":"style_PracticePage--GXktM4-i","leftColumn":"style_leftColumn--3e1SfOWA","detailsColumn":"style_detailsColumn--2A4T5mfG","detailsRow":"style_detailsRow--1-hPC7DS","map-not-found-text":"style_map-not-found-text--3zXHdgGR","mapNotFoundText":"style_map-not-found-text--3zXHdgGR","rightColumn":"style_rightColumn--3jJ64lVM","profile-section":"style_profile-section--220pBGMr","profileSection":"style_profile-section--220pBGMr","top-nav-background":"style_top-nav-background--dFe9zBYJ","topNavBackground":"style_top-nav-background--dFe9zBYJ"};


//////////////////
// WEBPACK FOOTER
// ./components/practice-page/src/styles/style.scss
// module id = 2155
// module chunks = 0